import { z } from "zod";

import { LIMITS } from "../constants.js";
import { attachmentIdSchema, draftIdSchema, isoUtcSchema, messageIdSchema } from "./common.js";

export const attachmentDispositionSchema = z.enum(["attachment", "inline"]);
export type AttachmentDisposition = z.infer<typeof attachmentDispositionSchema>;

/** Attachment metadata. Bytes always live in R2; this is the D1 truth. */
export const attachmentSchema = z.object({
  id: attachmentIdSchema,
  messageId: messageIdSchema.nullable(),
  draftId: draftIdSchema.nullable(),
  filename: z.string().min(1).max(255),
  contentType: z.string().min(1).max(255),
  sizeBytes: z.number().int().nonnegative(),
  disposition: attachmentDispositionSchema,
  contentId: z.string().max(512).nullable(),
  sha256: z.string().regex(/^[0-9a-f]{64}$/),
  /** Present on the attachment MIME allowlist; safe to render inline. */
  isRenderable: z.boolean(),
  /** True once a malware scan has completed (advisory until then). */
  scanned: z.boolean(),
  createdAt: isoUtcSchema,
});
export type Attachment = z.infer<typeof attachmentSchema>;

/** Query for a ranged download / inline preview. */
export const attachmentContentQuerySchema = z.object({
  disposition: z.enum(["attachment", "inline"]).optional(),
});

export const MAX_ATTACHMENT_BYTES = LIMITS.maxAttachmentBytes;
